import React from "react";

const Recensione = () => (
  <>
    <div className="recensione">
      <div className="titolo">
        <h1 className="tit">
          KANO Harry Potter <br /> Wand Coding Kit Review
        </h1>
      </div>
      <div className="icone">
        <img src="/svg/tech.svg" alt="tech" />
        <img src="/svg/monitor.svg" alt="coding" />
      </div>
    </div>
    <div className="text">
      <p>
        We've tried out the KANO Harry Potter Wand kit, a new kids coding gadget
        and app which has been released in time for Christmas 2018. I love Harry
        Potter myself so this product really appeals. At Tech Age Kids we always
        try and put a purpose behind coding to make it more engaging and this
        product does just that. <br /> <br />
        I tried the kit out with an 11-year-old Harry Potter fan who loves
        technology. <br /> <br />
        The kit comes in a sizeable box with an outer slipcover with all the
        practical information and a very nice storage box that the wand can be
        kept in. <br /> <br />
        The wand is covered with gauze material which makes it feel like a
        premium product. The nice box makes the kit an impressive gift though it
        does mean it takes some space to store. <br /> <br />
        The wand is made from plastic but is a nice size and the decoration is
        detailed. <br /> <br />
      </p>
      <div className="images">
        <img
          src="https://4.bp.blogspot.com/-vUOTkN5Qs_s/W7ymjpqsHMI/AAAAAAAAIE4/qXwRivJ5MOkHNSkJDXLgX68RaknuV9dmQCLcBGAs/s1600/Kano-Harry-Potter-Wand-Review-contents.jpg"
          alt="hp"
        />
        <img
          src="https://2.bp.blogspot.com/-xtCv9GS8pCA/W7ymi81JA4I/AAAAAAAAIEw/lyHQ5dN0884kC_etLHZHUcmD-fTz3VsrgCLcBGAs/s1600/Kano-Harry-Potter-Wand-Review-box.png"
          alt="hp1"
        />
        <img
          src="https://1.bp.blogspot.com/-F1GvBoJyQ_g/W7ymi5tgutI/AAAAAAAAIE0/wTAfaV2jBNYw6TgT3s27W1gK15H2DWl9ACLcBGAs/s1600/Kano-Harry-Potter-Wand-Review-circuit.jpg"
          alt="hp2"
        />
      </div>
    </div>
  </>
);

export default Recensione;
